export default from './Navbar';


/** WEBPACK FOOTER **
 ** ./app/components/navbar/index.js
 **/